import { BaseConfirmationModalProps } from 'global/Modal/BaseConfirmationModal';
import { Illustration, InfoText, InfoWrapper, ModalSuccess } from '../../utils/styled';

interface ModalSuccessInfoProps extends BaseConfirmationModalProps {
  src?: string;
  infoText?: string;
}

const ModalSuccessInfo = ({
  src = '/img/ipo-success.svg',
  infoText = 'Pemesanan Saham IPO STRK\nBerhasil Terkonfirmasi',
  confirmText = 'Selesai',
  ...props
}: ModalSuccessInfoProps) => (
  <ModalSuccess width={400} hideCancelButton confirmText={confirmText} {...props}>
    <InfoWrapper>
      <Illustration src={src} />
      <InfoText>{infoText}</InfoText>
    </InfoWrapper>
  </ModalSuccess>
);

export default ModalSuccessInfo;